import { render } from "./EditScopeView.vue?vue&type=template&id=5ca4d738"
import script from "./EditScopeView.vue?vue&type=script&lang=js"
export * from "./EditScopeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__